module.exports = __webpack_public_path__ + "static/media/icon_back_white.9d299db0.svg";